var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item',{attrs:{"href":"#"},on:{"click":function($event){return _vm.zoomExtent()}}},[_vm._v(_vm._s(_vm.$t('overview')))])
}
var staticRenderFns = []

export { render, staticRenderFns }